import { Injectable } from '@angular/core';
import { SessionService } from '../../Util/Session/session.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DailyAttendanceService {

  constructor(
    private http: HttpClient,
    private session: SessionService
  ) {
    environment.API_URL = this.session.GetUserDetails().ApiUrl;
   }

  Attendance_MaxConnect(Detail: any) {
    return this.http.post<any>(environment.API_URL + `Attendance_MaxConnect/Load`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  Attendance_Save(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_MaxConnectAttendance_new/Save`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }));
  }

  Add_Reliever(Detail: any) {
    return this.http.post<any>(environment.API_URL + `GetRelieverFor/Android`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  DailyAttendance(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_LoadAttendance_ByZoneClientSite/MaxConnect`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }

  FillCombo(Detail: any) {
    return this.http.post<any>(environment.API_URL + `ESS_LoadAttendance_MaxConnect/FillComboLoad`,
      this.session.SetClass(Detail)
    ).pipe(map(response => {
      if (response.Error_Code == '11' || response.Error_Code == '02') {
        this.session.End();
      } else {
        return response;
      }
    }))
  }
}
